/**
 * ApprovalQueuePage - Approval workflow monitoring dashboard
 *
 * Surfaces the ApprovalQueueDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides visibility into pending approvals, SLA status, and escalation patterns.
 *
 * Route: /admin/approval-queue
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconCheckbox } from '@tabler/icons-react';

import { ApprovalQueueDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ApprovalQueuePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="blue">
            <IconCheckbox size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Approval Queue</Title>
            <Text size="sm" c="dimmed">
              Pending approvals, SLA compliance, and escalation monitoring
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ApprovalQueueDashboard />
    </Container>
  );
}

export default ApprovalQueuePage;
